<template>
  <div class="navbar_wrap hidden-xs-only" v-show="isVisible">
    <div class="navbar-container" @mouseleave="hideMainSubmenu" ref="navbarContainer">
      <!-- 导航主栏 -->
      <nav class="navbar" :style="mainMenuContentStyle">
        <div class="navbar_left">
          <!-- 璟点台球集团（带下拉） -->
          <div
              class="nav-item has-submenu"
              @mouseenter="showSubmenu('group', 'groupRef')"
              @mouseleave="hideSubmenu"
              ref="groupRef"
              @click="onchangeLink('home')"
          >
            璟点台球集团 ▾
          </div>

          <!-- 品牌（带下拉） -->
          <div
              class="nav-item has-submenu"
              @mouseenter="showSubmenu('brand', 'brandRef')"
              @mouseleave="hideSubmenu"
              ref="brandRef"
              @click="onchangeLink('home')"
          >
            品牌 ▾
          </div>

          <div class="nav-item" @mouseenter="hideSubmenu" @mouseleave="hideSubmenu" @click="onchangeLink('contest')">
            赛事
          </div>

          <div class="nav-item" @mouseenter="hideSubmenu" @mouseleave="hideSubmenu"  @click="onchangeLink('social')">
            社交平台
          </div>

          <div class="nav-item" @mouseenter="hideSubmenu" @mouseleave="hideSubmenu"  @click="onchangeLink('mediaNews')">
            媒体中心
          </div>
        </div>

        <!-- 右侧logo（注释保留） -->
        <!--        <div class="logo">-->
        <!--          <img src="../../../assets/img/home/navbar/header_logo2.png" alt="璟点logo" />-->
        <!--        </div>-->
      </nav>

      <!-- 子菜单容器（核心修改：绑定动态样式，不再全屏） -->
      <div class="submenu-container" v-if="activeSubmenu" @mouseenter="keepSubmenu" @mouseleave="hideSubmenu" :style="submenuContainerStyle">
        <!-- 移除全屏分割线（不再适配全屏，改为子菜单内短分割线） -->
        <!--        <div class="submenu-line"></div>-->

        <!-- 集团子菜单（静态） -->
        <div class="submenu-content" v-if="activeSubmenu === 'group'">
          <div class="submenu-item" @click="onchangeLink('group_1')">公司简介</div>
          <div class="submenu-item" @click="onchangeLink('group_2')">董事长简介</div>
          <div class="submenu-item" @click="onchangeLink('group_3')">公司大事件</div>
        </div>

        <!-- 品牌子菜单（静态） -->
        <div class="submenu-content" v-if="activeSubmenu === 'brand'">
          <!-- 修复：key使用唯一标识item.id，避免colIndex重复问题 -->
          <div class="submenu-item"
               v-for="item in brandList"
               :key="item.id || item.name"
               @click="handleBrandClick(item)"
          >
            {{item.name}}
          </div>
        </div>

        <!-- 产品子菜单（保留，若需启用可取消注释） -->
        <div class="submenu-content brand-submenu" v-if="activeSubmenu === 'product'">
          <div class="category-column" v-for="(category, idx) in brandCategories" :key="idx">
            <h3 class="category-title">{{ category.name }}</h3>
            <ul class="brand-list">
              <li
                  class="submenu-item"
                  v-for="(brand, bIdx) in category.children"
                  :key="bIdx"
                  @click="onchangeBrandLink(brand.id)"
              >
                {{ brand.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBrandList, getProductClassify} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  name: 'Navbar',
  data() {
    return {
      activeSubmenu: null,
      submenuContentStyle: {}, // 保留但不再使用（兼容原有结构）
      submenuContainerStyle: {}, // 新增：控制子菜单容器定位（核心）
      mainMenuContentStyle: {},
      isHoveringSubmenu: false,
      isVisible: true,
      brandCategories: [],
      brandList: [], //旗下品牌数组
      loading: false,
      submenuTimer: null
    }
  },
  created() {
    this.getBrandList();
  },
  activated() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  deactivated() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
    this.submenuTimer && clearTimeout(this.submenuTimer);
  },
  methods: {
    // 旗下品牌点击核心逻辑（保留）
    handleBrandClick(item) {
      if (!item) {
        this.$message?.warning("该品牌暂无跳转链接");
        return;
      }

      const { url, urlType } = item;

      try {
        if (urlType === '1') {
          // if (!url || !/^https?:\/\//.test(url)) {
          //   this.$message?.warning("外部链接格式错误，请检查");
          //   return;
          // }
          window.open(url, '_blank', 'noopener,noreferrer');
        } else if (urlType === '2') {
          if (!url && !item.id) {
            this.$message?.warning("缺少跳转参数");
            return;
          }
          this.$router.push({
            path: '/productDetail',
            query: {
              productId: item.id,
              type: 'brand'
            }
          });
        } else {
          this.$message?.info("该品牌暂无跳转链接");
        }
      } catch (error) {
        console.error("品牌跳转失败：", error);
        this.$message?.error("跳转失败，请稍后重试");
      }
    },

    // 获取品牌列表（保留）
    async getBrandList() {
      try {
        this.loading = true;
        const res = await getBrandList();
        if (res.code === 200) {
          this.brandList = res.data || [];
        } else {
          this.$message?.error(res.returnMsg || "获取产品列表失败");
          this.brandList = [];
        }
      } catch (error) {
        console.error("产品列表请求失败：", error);
        this.$message?.error("网络异常，请稍后重试");
        this.brandList = [];
      } finally {
        this.loading = false;
      }
    },

    // 请求品牌子菜单数据（保留）
    async fetchBrandSubmenu() {
      try {
        const res = await getProductClassify();
        this.brandCategories = res.data || [];
      } catch (err) {
        console.error('品牌子菜单数据请求失败：', err);
      }
    },

    // 显示子菜单（核心修改：计算贴合主菜单项的位置）
    showSubmenu(type, refName) {
      this.activeSubmenu = type;
      this.isHoveringSubmenu = true;
      this.$nextTick(() => {
        this.calculateSubmenuPosition(refName);
      });
    },

    hideMainSubmenu() {
      this.mainMenuContentStyle = {};
    },

    hideSubmenu() {
      this.isHoveringSubmenu = false;
      this.submenuTimer && clearTimeout(this.submenuTimer);
      this.submenuTimer = setTimeout(() => {
        !this.isHoveringSubmenu && (this.activeSubmenu = null);
      }, 100);
    },

    keepSubmenu() {
      this.isHoveringSubmenu = true;
    },

    // 核心修改：计算子菜单容器位置（完全贴合主菜单项，移除+5px偏移）
    calculateSubmenuPosition(refName) {
      const navItem = this.$refs[refName];
      const container = this.$refs.navbarContainer;
      if (!navItem || !container) return;

      // 获取主菜单项和容器的位置信息（相对视口）
      const navItemRect = navItem.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      // 计算子菜单相对于容器的定位（关键：移除+5px，实现完全紧贴）
      this.submenuContainerStyle = {
        left: `${navItemRect.left - containerRect.left}px`, // 与主菜单项左对齐
        top: `${navItemRect.bottom - containerRect.top}px`, // 紧贴主菜单项底部（移除+5px）
        width: 'auto', // 宽度自适应内容
        minWidth: `${navItemRect.width}px`, // 最小宽度与主菜单项一致
        maxWidth: '500px', // 限制最大宽度，避免过宽
        zIndex: 9999
      };

      // 主菜单样式（保留原有逻辑）
      this.mainMenuContentStyle = {
        background: `#FFFFFF`,
        color: `#0f0f0f`,
      };
    },

    // 窗口resize时重新计算位置（保留并适配）
    handleResize() {
      if (this.activeSubmenu) {
        const refName = this.activeSubmenu === 'group' ? 'groupRef' : 'brandRef';
        this.calculateSubmenuPosition(refName);
      }
    },

    //品牌下产品详情跳转（保留）
    onchangeBrandLink(id){
      if(id){
        if(id == ImageTypeEnum.TABLE_PRODUCT_DETAIL_LIST.value){
          this.$router.push({
            path: '/table',
          })
        }else{
          this.$router.push({
            path: '/brand_cl',
            query: {
              productId: id,
            }
          })
        }
      }
    },

    // 路由跳转（保留）
    onchangeLink(routePath) {
      const routeMap = {
        'home': '/home',
        'group_1': "/company?flag=com",
        'group_2': "/company?flag=chairmans",
        'group_3': "/company?flag=majorEvent",
        'contest': "/contest",
        'social': "/social",
        'mediaNews': "/mediaNews",
      };
      const targetPath = routeMap[routePath];
      targetPath && this.$router.push(targetPath).catch(err => {
        !err.message.includes('Avoided redundant navigation') && console.error('路由跳转失败：', err);
      });
    },

    // 滚动控制显示（保留）
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      this.isVisible = scrollTop <= 300;
    }
  },
  mounted() {
    this.fetchBrandSubmenu();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
    this.submenuTimer && clearTimeout(this.submenuTimer);
  }
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  .navbar-container {
    width: 100%;
    position: relative; // 子菜单容器的定位参考
    color: #FFFFFF;
  }

  .navbar {
    display: flex;
    align-items: center;
    padding: 0 50px;
    height: 100px;
    position: relative;
    z-index: 10;
    transition: all 0.2s ease;
  }

  .navbar_left {
    display: flex;
    width: 80%;
    height: 100%;
  }

  .nav-item {
    padding: 0 60px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 500;
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    transition: color 0.2s ease;
    position: relative; // 辅助定位参考

    &.has-submenu:hover {
      color: #f9b234;
    }
  }

  .logo {
    width: 20%;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;

    img {
      height: 60px;
      object-fit: contain;
    }
  }

  // 核心修改：子菜单容器（完全紧贴，无任何偏移）
  .submenu-container {
    position: absolute; // 相对于.navbar-container
    background: #fff;
    color: #0f0f0f;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15); // 增强阴影提升层级
    border-radius: 8px; // 圆角更美观
    padding: 15px 20px; // 缩小内边距
    box-sizing: border-box;
    overflow: hidden; // 隐藏溢出
    transition: all 0.2s ease; // 过渡动画
    margin: 0; // 关键：移除默认margin，避免偏移
    border-top: 2px solid #FFFFFF; // 可选：添加顶部边框，视觉上更贴合主菜单
  }

  // 子菜单内部分割线（替代原全屏分割线）
  .submenu-line {
    width: 100%;
    height: 2px;
    background-color: #0f0f0f;
    margin-bottom: 10px;
    border-radius: 1px;
  }

  .submenu-content {
    min-width: 200px; // 最小宽度兜底
    min-height: auto; // 取消固定最小高度
    padding: 5px 0;
    top: 0; // 重置top，不再偏移
    margin: 0; // 确保内容无偏移
  }

  // 品牌子菜单（适配非全屏）
  .brand-submenu {
    display: flex;
    flex-direction: column; // 纵向排列适配窄宽度
    gap: 10px;
    padding: 5px 0;
    width: 100%;
    margin: 0; // 移除多余margin
  }

  // 分类列（适配非全屏）
  .category-column {
    min-width: 180px;
    width: 100%;
    margin-bottom: 10px;
    text-align: left;
  }

  // 分类标题（保留）
  .category-title {
    font-size: 16px;
    font-weight: 700;
    color: #0f0f0f;
    margin: 0 0 10px 0;
    padding: 0 0 5px 0;
    border-bottom: 1px solid #eee;
    text-align: left;
    white-space: normal;
    word-wrap: break-word;
  }

  .brand-list {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: left;
  }

  // 子菜单项（优化交互）
  .submenu-item {
    font-size: 14px; // 微调字体
    padding: 8px 10px; // 增大点击区域
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 4px;
    text-align: left;
    white-space: nowrap; // 单行显示

    &:hover {
      color: #f9b234;
      background: #f8f8f8; // hover背景更易识别
      padding-left: 12px;
    }
  }

  // 隐藏原全屏分割线（不再需要）
  .line_logo_black, .line_black, .logo_line_black {
    display: none;
  }

  // 保留其他分割线样式但隐藏（避免冲突）
  .line_logo, .line, .logo_line {
    display: none;
  }
}

// 响应式适配（调整子菜单适配小屏幕）
@media (max-width: 1200px) {
  .navbar_wrap .nav-item {
    padding: 0 30px;
    font-size: 18px;
  }
  .submenu-container {
    min-width: 180px;
    max-width: 400px;
    padding: 12px 15px;
  }
  .submenu-item {
    font-size: 13px;
    padding: 7px 8px;
  }
}

@media (max-width: 768px) {
  .navbar_wrap .nav-item {
    padding: 0 15px;
    font-size: 16px;
  }
  .submenu-container {
    min-width: 160px;
    max-width: 350px;
    padding: 10px 12px;
  }
  .submenu-item {
    font-size: 12px;
    padding: 6px 7px;
  }
}
</style>